import moment from 'moment';
import 'moment/locale/ko.js';
import i18n from '@common/i18n';

const FORMAT_DATE_ISO_DATE = 'YYYY-MM-DD';
const FORMAT_DATE_ISO_DATETIME = 'YYYY-MM-DDTHH:mm:ssZ';
const FORMAT_DATE_TIME_MIN_WITH_APMP = {
    ko: 'YYYY. M. D. HH:mm',
    id: 'D MMM YYYY HH:mm',
    en: 'D MMM, YYYY, h:mm a',
    'zh-TW': 'YYYY/M/D a h:mm',
};
const FORMAT_DATE = {
    ko: 'YYYY. M. D.',
    id: 'DD/MM/YYYY',
    en: 'DD/MM/YYYY',
    'zh-TW': 'YYYY/M/D',
};

const FORMAT_년월일 = {
    ko: 'YYYY년 M월 D일',
    id: 'D MMMM YYYY',
    en: 'D MMMM YYYY',
    'zh-TW': 'YYYY年 M月 D日',
}

const FORMAT_MONTH_DATE_DAY = {
    ko: 'M.D(dd)',
    id: 'M.D(dd)',
    en: 'M.D(dd)',
    'zh-TW': 'M.D(dd)',
}

const FORMAT_YEAR_MONTH_DATE_DAY = {
    ko: 'YYYY. M. D(dd)',
    id: 'YYYY. M. D(dd)',
    en: 'YYYY. M. D(dd)',
    'zh-TW': 'YYYY. M. D(dd)',
}

export const FORMAT_MONTH_DATE_DAY_FOR_DATEPICKER = {
    ko: 'M.d(D)',
    id: 'M.d(D)',
    en: 'M.d(D)',
    'zh-TW': 'M.d(D)',
}

/**
 * 외부 주입용
 * @type {Date}
 */
let nowDate;

/**
 * 현재 시각 반환
 * @returns {Date}
 */
export function getNowDate() {
    return nowDate && new Date(nowDate.getTime()) || new Date();
}

export function setNowDate(date) {
    nowDate = date;
}

export function toISOFormat(date) {
    return moment(date).format(FORMAT_DATE_ISO_DATETIME);
}

export function toISODateFormat(date) {
    return moment(date).format(FORMAT_DATE_ISO_DATE);
}

export function toMonthDateDayFormat(date) {
    return moment(date).format(FORMAT_MONTH_DATE_DAY[i18n.locale]);
}

export function toYearMonthDateDayFormat(date) {
    return moment(date).format(FORMAT_YEAR_MONTH_DATE_DAY[i18n.locale]);
}

export function toDateFromISOFormat(string) {
    return moment(string, FORMAT_DATE_ISO_DATETIME).toDate();
}

export function toResponseViewFormat(string) {
    return moment(string, FORMAT_DATE_ISO_DATETIME).locale(i18n.locale).format(FORMAT_DATE_TIME_MIN_WITH_APMP[i18n.locale]).toString();
}

export function toDateFormat(string) {
    return moment(string, FORMAT_DATE_ISO_DATETIME).locale(i18n.locale).format(FORMAT_DATE[i18n.locale]).toString();
}

export function toDate년월일Format(string) {
    return moment(string, FORMAT_DATE_ISO_DATETIME).locale(i18n.locale).format(FORMAT_년월일[i18n.locale]).toString();
}

const ONE_DAY_MILLS = 24/*시간*/ * 60/*분*/ * 60/*초*/ * 1000/*밀리초*/;

/**
 * 두 날짜 사이 일자를 반환
 * @param startDate
 * @param endDate
 * @returns {number}
 */
export function getDiffDays(startDate, endDate) {
    const startDate1 = new Date(startDate);
    const endDate1 = new Date(endDate);

    startDate1.setHours(0, 0, 0, 0);
    endDate1.setHours(0, 0, 0, 0);

    const diffMills = endDate1.getTime() - startDate1.getTime();
    return diffMills / ONE_DAY_MILLS;
}
